import SliderImageSeparator from "./common/SliderImageSeparator"
import { validate } from "../utils/contactValidation"
import ImageTitleItem from "./common/ImageTitleItem"
import { useEffect, useRef, useState } from "react"
import { useMediaQuery } from "react-responsive"
import ReCAPTCHA from 'react-google-recaptcha'
import { path } from "../utils/properties"
import { Link } from "react-router-dom"
import axios from "axios"
import Cookies from "js-cookie";
import ImageSlider from "./common/ImageSlider"


const Contact = () => {

    const [visibleModal, setVisibleModal] = useState(false)
    const isMobile = useMediaQuery({ maxWidth: 1280 })
    const [send, setSend] = useState(false)
    const [info, setInfo] = useState("")
    const recaptcha = useRef()

    const [formData, setFormData] = useState({
        name: "",
        surname: "",
        town: "",
        country: "",
        institution: "",
        department: "",
        phone: "",
        email: "",
        message: "",
        accepted: false,
    })

    const [cookieConsent, setCookieConsent] = useState(false);

    useEffect(() => {
        document.title = 'Séneca - Formulario de contacto'
        window.scrollTo(0, 0)
        const cookieConsent = Cookies.get("cookie-consent");
        if (cookieConsent) {
            try {
                const parsedCookie = JSON.parse(cookieConsent)
                if (parsedCookie["Advertising"]?.["consented"] && parsedCookie["Analytics"]?.["consented"] && parsedCookie["Social"]?.["consented"])
                    setCookieConsent(true)
            } catch (_) { }
        }
    }, []);


    const handleValueChange = (e) => {
        const { id, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [id]: type === "checkbox" ? checked : value,
        });
    };


    const handleCreateContact = async (e) => {

        e.preventDefault()

        const captchaValue = recaptcha?.current.getValue()

        const { isOk, resultMessage } = validate(formData)
        setInfo(resultMessage)

        if (!isOk) {
            setVisibleModal(true)
            return
        }

        if (!captchaValue) {
            setInfo("Por favor, verifica el Captcha")
            setVisibleModal(true)
            return
        }

        try {
            const res = await axios.post(path + "/api/verify", { captchaValue: captchaValue })
            const { data } = res

            if (!data.success) {
                setInfo('Error al validar Captcha')
                setVisibleModal(true)
                return
            }

            const response = await axios.post(path + "/api/sendcontactmail/", { contact: formData, captchaValue })
            const status = response.data.status
            const message = response.data.body

            if (status === 200) {
                setFormData({
                    name: "",
                    surname: "",
                    town: "",
                    country: "",
                    institution: "",
                    department: "",
                    phone: "",
                    email: "",
                    message: "",
                    accepted: false,
                });
                recaptcha.current?.reset();
                setSend(true)
                window.scrollTo(0, 300)
            } else {
                setInfo(message)
                setVisibleModal(true)
            }
        } catch (error) {
            setInfo("No se ha podido enviar el formulario. Inténtalo de nuevo más tarde.")
            setVisibleModal(true)
        }

    }

    return (

        <main className="generic-main">

            <ImageTitleItem
                imageURL="/images/contact/contacto-1.jpg"
                imageURLMobile="/images/contact/contacto-1m.jpg"
                titleText="Formulario de contacto"
                icon="bi bi-person-lines-fill blue-icon"
                subtitleText="En Séneca queremos escucharle"
            />
            <SliderImageSeparator />



            {(send)
                ?
                <section className="flex w100 white-bkg">
                    <section className={(isMobile) ? "main-middle-section-mobile gap-10" : "main-technology-section row acenter gap-10"}>
                        <img loading="lazy" alt="Imagen" className="check-image" src="/images/green-check.png"></img>
                        <label>Gracias por contactarnos. Hemos recibido tu mensaje y nuestro equipo te responderá lo antes posible.</label>
                    </section>
                </section>
                :
                <>
                    <section className="flex w100 white-bkg">


                        <section className={(isMobile) ? "main-middle-section-mobile" : "main-technology-section"}>
                            <p className='middle-section-label'>
                                Las personas que trabajamos en Séneca queremos ayudarle. Indíquenos sus datos y la forma a través de la cual prefiere en que nos pongamos en contacto con usted y responderemos a todas sus preguntas sobre nuestros productos y servicios Séneca.
                            </p>
                            <p className='middle-section-label'><strong>Los campos marcados con * son obligatorios</strong></p>
                        </section>
                    </section>


                    <section className="flex w100 white-bkg">
                        <section className={(isMobile) ? "main-middle-section-mobile" : "main-technology-section"}>


                            {(cookieConsent) ?

                                <form className="contact-form-grid contact-form-card" onSubmit={handleCreateContact} >

                                    <div className="field-group">
                                        <input id="name" className="footer-input" placeholder=" " value={formData.name} onChange={handleValueChange} />
                                        <label htmlFor="name" className="floating-label">Nombre *</label>
                                    </div>

                                    <div className="field-group">
                                        <input id="surname" className="footer-input" placeholder=" " value={formData.surname} onChange={handleValueChange} />
                                        <label htmlFor="surname" className="floating-label">Apellidos *</label>
                                    </div>

                                    <div className="field-group">
                                        <input id="town" className="footer-input" placeholder=" " value={formData.town} onChange={handleValueChange} />
                                        <label htmlFor="town" className="floating-label">Localidad</label>
                                    </div>

                                    <div className="field-group">
                                        <input id="country" className="footer-input" placeholder=" " value={formData.country} onChange={handleValueChange} />
                                        <label htmlFor="country" className="floating-label">País</label>
                                    </div>

                                    <div className="field-group">
                                        <input id="institution" className="footer-input" placeholder=" " value={formData.institution} onChange={handleValueChange} />
                                        <label htmlFor="institution" className="floating-label">Empresa/Institución *</label>
                                    </div>

                                    <div className="field-group">
                                        <input id="department" className="footer-input" placeholder=" " value={formData.department} onChange={handleValueChange} />
                                        <label htmlFor="department" className="floating-label">Departamento</label>
                                    </div>

                                    <p className="contact-form-note field-group-full">Forma de contacto (al menos una) *</p>

                                    <div className="field-group">
                                        <input id="phone" className="footer-input" placeholder=" " value={formData.phone} onChange={handleValueChange} />
                                        <label htmlFor="phone" className="floating-label">Teléfono</label>
                                    </div>

                                    <div className="field-group">
                                        <input id="email" className="footer-input" placeholder=" " value={formData.email} onChange={handleValueChange} />
                                        <label htmlFor="email" className="floating-label">E-mail</label>
                                    </div>

                                    <div className="field-group field-group-full">
                                        <textarea id="message" className="footer-textarea" placeholder=" " rows="5" value={formData.message} onChange={handleValueChange}></textarea>
                                        <label htmlFor="message" className="floating-label">Mensaje</label>
                                    </div>

                                    <section className="flex gap-5 acenter jcenter field-group-full">
                                        <input type="checkbox" id="accepted" checked={formData.accepted} onChange={handleValueChange} />
                                        <label htmlFor="accepted" className="footer-text-strong">Acepto la</label>
                                        <Link to="/legal/" className="footer-link-blue">Política de Privacidad</Link>
                                    </section>

                                    <section className="flex col gap-10 acenter jcenter field-group-full">
                                        <ReCAPTCHA ref={recaptcha} sitekey={process.env.REACT_APP_SITE_KEY} />
                                        <input value="Enviar" type="submit" className="send-button" />
                                    </section>
                                </form>
                                :
                                <section className="flex col gap-10 acenter jcenter gc2">
                                    <article className="cookie-warning">
                                        <label>Por favor, acepte las cookies para poder utilizar el formulario de contacto</label>
                                    </article>
                                </section>}




                        </section>
                    </section>
                </>

            }


            <section className={visibleModal ? "contact-modal-bkg" : "hidden"}>
                <section className="contact-modal">
                    <i className="bi bi-exclamation-circle blue-icon"></i>
                    <article className="contact-label-container">{info}</article>
                    <button className="close-button" onClick={() => setVisibleModal(false)}>Cerrar</button>
                </section>
            </section>

        </main>

    )

}

export default Contact